// import { useState } from "react";
// import axios from "axios";
// import Registration from "./RegistrationNew";


// const LOGIN_URL = "https://ecom.cyberathon.com/index.php/Api/login_registration";

// function LoginAPI({ show, onClose }) {
//     const [showSignUp, setShowSignUp] = useState(false);
//     const [showPassword, setShowPassword] = useState(false);

//     const [formData, setFormData] = useState({
//         email: "",
//         password: ""
//     });

//     const handleChange = (e) => {
//         setFormData({
//             ...formData,
//             [e.target.name]: e.target.value
//         });
//     };

//     // const handleSubmit = async (e) => {
//     //     e.preventDefault();

//     //     try {
//     //         const response = await axios.post(LOGIN_URL, formData, {
//     //             headers: {"Content-Type":"application/json"}
//     //         });
    
//     //         console.log("LOGIN RESPONSE:",response.data)

            
//     //             if (response.data.status === true) {
//     // alert("Login Successful!");

//     // // Save user data
//     // sessionStorage.setItem("isLoggedIn", "true");
//     // sessionStorage.setItem("userName", response.data.user?.name || "User");

//     // onClose();

//     // // Reload page so Navbar updates
//     // window.location.reload();
//     //   } 
//     // else{
//     //     alert(response.data.message || "Login Failed");
//     //         }
//     //     } catch (error) {
//     //         console.log(error);
//     //         alert("API Error");
//     //     }
//     // };

//     const handleSubmit = async (e) => {
//   e.preventDefault();

//   try {
//     const response = await axios.post(LOGIN_URL, formData, {
//       headers: { "Content-Type": "application/json" }
//     });

//     console.log("LOGIN RESPONSE:", response.data);

//     if (response.data.status === true) {

//       const user = response.data.user; // shortcut

// // ✅ FULL NAME SPLIT
//   const fullName = user.full_name || "";
//   const nameParts = fullName.trim().split(" ");
//   const firstName = nameParts[0] || "";
//   const lastName = nameParts.slice(1).join(" "); // surname safe

//       alert("Login Successful!");

//       // 🟢 SAVE USER DATA CORRECTLY
//       sessionStorage.setItem("isLoggedIn", "true");
//       sessionStorage.setItem("userId", user.user_id); 
//       sessionStorage.setItem("userName", user.full_name);
//      sessionStorage.setItem("first_name", firstName);
//   sessionStorage.setItem("last_name", lastName);
//       sessionStorage.setItem("email", user.email);
//  sessionStorage.setItem("phone", user.phone || "");

//       // 🟢 MERGE GUEST CART (optional but recommended)
//       const guestCart = JSON.parse(localStorage.getItem("guest_cart")) || [];
//       const userCartKey = `cart_${user.email}`;
//       const userCart = JSON.parse(localStorage.getItem(userCartKey)) || [];

//       const mergedCart = [...userCart, ...guestCart];
//       localStorage.setItem(userCartKey, JSON.stringify(mergedCart));

//       localStorage.removeItem("guest_cart");

//       onClose();
//       window.location.reload();
//     } 
//     else {
//       alert(response.data.message || "Login Failed");
//     }

//   } catch (error) {
//     console.log(error);
//     alert("API Error");
//   }
// };


// // const handleSubmit = async (e) => {
// //   e.preventDefault();

// //   try {
// //     const response = await axios.post(LOGIN_URL, formData, {
// //       headers: { "Content-Type": "application/json" }
// //     });

// //     console.log("LOGIN RESPONSE:", response.data);

// //     if (response.data.status === true) {
// //       alert("Login Successful!");

// //       // 🟢 SAVE USER DATA IN SESSION STORAGE
// //       sessionStorage.setItem("isLoggedIn", "true");
// //       sessionStorage.setItem("userId", response.data.user_id);   // <-- ADD HERE
// //       sessionStorage.setItem("userEmail", response.data.email);  // <-- ADD HERE

// //       sessionStorage.setItem("userName", response.data.user?.name || "User");

// // // 🔹 Merge Guest Cart into User Cart
// //   const userEmail = response.data.email;
// //   const guestCart = JSON.parse(localStorage.getItem("guest_cart")) || [];
// //   const userCartKey = `cart_${userEmail}`;
// //   const userCart = JSON.parse(localStorage.getItem(userCartKey)) || [];

// //   // Merge items (you can also handle duplicates by increasing quantity)
// //   const mergedCart = [...userCart, ...guestCart];
// //   localStorage.setItem(userCartKey, JSON.stringify(mergedCart));

// //   // Clear guest cart
// //   localStorage.removeItem("guest_cart");


// //       onClose();  
// //       window.location.reload();  // Navbar update
// //     } 
// //     else {
// //       alert(response.data.message || "Login Failed");
// //     }

// //   } catch (error) {
// //     console.log(error);
// //     alert("API Error");
// //   }
// // };

//     if (!show) return null;

//     return (
//         <>
//             <div
//                 className="modal fade show d-block"
//                 tabIndex="-1"
//                 style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
//             >
//                 <div className="modal-dialog modal-dialog-centered">
//                     <div className="modal-content">

//                         {/* Header */}
//                         <div
//                             className="modal-header no-border d-flex flex-column align-items-center position-relative pt-0"
//                             style={{ borderBottom: "none" }}
//                         >
//                             <div className="w-100 d-flex justify-content-between align-items-center p-0">
//                                 <h3 className="modal-title fw-bold text-center pt-0 text-dark fs-2">Login</h3>
//                                 <button
//                                     type="button"
//                                     className="btn-close"
//                                     onClick={onClose}
//                                 ></button>
//                             </div>
//                         </div>

//                         {/* Body */}
//                         <div className="modal-body pt-0">
//                             <form onSubmit={handleSubmit}>

//                                 {/* Email */}
//                                 <div className="mb-3 pt-2">
//                                     <label className="form-label">Email address</label>
//                                     <input
//                                         type="email"
//                                         name="email"
//                                         className="form-control"
//                                         placeholder="Enter email"
//                                         value={formData.email}
//                                         onChange={handleChange}
//                                         required
//                                     />
//                                 </div>

//                                 {/* Password */}
//                                 <div className="mb-3">
//                                     <label className="form-label">Password</label>
//                                     <input
//                                         type="password"
//                                         name="password"
//                                         className="form-control"
//                                         placeholder="Enter password"
//                                         value={formData.password}
//                                         onChange={handleChange}
//                                         required
//                                     />
//                                 </div>

//                                 {/* Checkbox + ForgetPassword */}
//                                 <div className="d-flex justify-content-between align-items-center mb-3">
//                                     <div className="form-check">
//                                         <input
//                                             type="checkbox"
//                                             className="form-check-input"
//                                             id="remember"
//                                         />
//                                         <label className="form-check-label" htmlFor="remember">
//                                             Remember me
//                                         </label>
//                                     </div>
//                                     <span
//                                         className="text-danger text-decoration-underline"
//                                         style={{ cursor: "pointer" }}
//                                         onClick={() => setShowPassword(true)}
//                                     >
//                                         Forget Password
//                                     </span>
//                                 </div>

//                                 {/* Submit */}
//                                 <button
//                                     type="submit"
//                                     className="bg-col fw-bold text-light border-0 rounded-2 p-2 w-100"
//                                 >
//                                     Login
//                                 </button>

//                                 {/* SignUp toggle */}
//                                 <div className="d-flex justify-content-center align-items-center gap-1 pt-3 pb-1">
//                                     <span>Don't have an account?</span>
//                                     <span
//                                         className="text-primary text-decoration-underline"
//                                         style={{ cursor: "pointer" }}
//                                         onClick={() => setShowSignUp(true)}
//                                     >
//                                         SignUp
//                                     </span>
//                                 </div>
//                             </form>
//                         </div>

//                     </div>
//                 </div>
//             </div>

//             {/* Modals */}
//             {/* <SignUp show={showSignUp} onClose={() => setShowSignUp(false)} /> */}
//                         <Registration show={showSignUp} onClose={() => setShowSignUp(false)} />

//             {/* <ForgetPassword show={showPassword} onClose={() => setShowPassword(false)} /> */}
//         </>
//     );
// }

// export default LoginAPI;


// import { useState } from "react";
// import axios from "axios";
// import Registration from "./RegistrationNew";
// import { useCart } from "../../Context/CartContext";

// const LOGIN_URL = "https://ecom.cyberathon.com/index.php/Api/login_registration";

// function LoginAPI({ show, onClose }) {
//   const { setCartCount } = useCart();
//   const [showSignUp, setShowSignUp] = useState(false);
//   const [formData, setFormData] = useState({ email: "", password: "" });

//   const handleChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     try {
//       const response = await axios.post(LOGIN_URL, formData, { headers: { "Content-Type": "application/json" } });
//       if (response.data.status === true) {
//         const user = response.data.user;

//         sessionStorage.setItem("isLoggedIn", "true");
//         sessionStorage.setItem("userId", user.user_id);
//         sessionStorage.setItem("userName", user.full_name);
//         sessionStorage.setItem("userEmail", user.email);

//         // Merge guest cart
//         const guestCart = JSON.parse(localStorage.getItem("guest_cart")) || [];
//         const userCartKey = `cart_${user.email}`;
//         const userCart = JSON.parse(localStorage.getItem(userCartKey)) || [];
//         const mergedCart = [...userCart, ...guestCart];
//         localStorage.setItem(userCartKey, JSON.stringify(mergedCart));
//         localStorage.removeItem("guest_cart");

//         // Update cart context immediately
//         setCartCount(mergedCart.length);

//         // Trigger cart page update
//         window.dispatchEvent(new Event("cartUpdated"));

//         alert("Login Successful!");
//         onClose();
//       } else alert(response.data.message || "Login Failed");
//     } catch (error) {
//       console.log(error);
//       alert("API Error");
//     }
//   };

//   if (!show) return null;

//   return (
//     <>
//       <div className="modal fade show d-block" tabIndex="-1" style={{ backgroundColor: "rgba(0,0,0,0.5)" }}>
//         <div className="modal-dialog modal-dialog-centered">
//           <div className="modal-content">
//             <div className="modal-header no-border d-flex flex-column align-items-center position-relative pt-0">
//               <div className="w-100 d-flex justify-content-between align-items-center p-0">
//                 <h3 className="modal-title fw-bold text-center pt-0 text-dark fs-2">Login</h3>
//                 <button type="button" className="btn-close" onClick={onClose}></button>
//               </div>
//             </div>
//             <div className="modal-body pt-0">
//               <form onSubmit={handleSubmit}>
//                 <div className="mb-3 pt-2">
//                   <label className="form-label">Email address</label>
//                   <input type="email" name="email" className="form-control" placeholder="Enter email" value={formData.email} onChange={handleChange} required />
//                 </div>
//                 <div className="mb-3">
//                   <label className="form-label">Password</label>
//                   <input type="password" name="password" className="form-control" placeholder="Enter password" value={formData.password} onChange={handleChange} required />
//                 </div>
//                 <button type="submit" className="bg-col fw-bold text-light border-0 rounded-2 p-2 w-100">Login</button>
//                 <div className="d-flex justify-content-center align-items-center gap-1 pt-3 pb-1">
//                   <span>Don't have an account?</span>
//                   <span className="text-primary text-decoration-underline" style={{ cursor: "pointer" }} onClick={() => setShowSignUp(true)}>SignUp</span>
//                 </div>
//               </form>
//             </div>
//           </div>
//         </div>
//       </div>
//       <Registration show={showSignUp} onClose={() => setShowSignUp(false)} />
//     </>
//   );
// }

// export default LoginAPI;


//real page before change start 10-02-2026
// import { useState } from "react";
// import axios from "axios";
// import Registration from "./RegistrationNew";
// import { useNavigate } from "react-router-dom";

// const LOGIN_URL = "https://ecom.cyberathon.com/index.php/Api/login_registration";
// const MERGE_CART_URL = "https://ecom.cyberathon.com/index.php/Api/merge_cart";

// /* ✅ ADD THIS */
// const BIGSHIP_LOGIN_URL = "/api-bigship/api/login/user";

// function LoginAPI({ show, onClose }) {

//   const navigate = useNavigate(); // ✅ REQUIRED

//   const [showSignUp, setShowSignUp] = useState(false);
//   const [showPassword, setShowPassword] = useState(false);

//   const [formData, setFormData] = useState({
//     email: "",
//     password: ""
//   });

//   const handleChange = (e) => {
//     setFormData({
//       ...formData,
//       [e.target.name]: e.target.value
//     });
//   };

//   /* ================= LOGIN SUBMIT ================= */
//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     try {
//       const response = await axios.post(LOGIN_URL, formData, {
//         headers: { "Content-Type": "application/json" }
//       });

//       if (response.data.status === true) {

//         const user = response.data.user;
// // ✅ FULL NAME SPLIT
//  const fullName = user.full_name || "";
//  const nameParts = fullName.trim().split(" ");
//   const firstName = nameParts[0] || "";
//   const lastName = nameParts.slice(1).join(" "); // surname safe


//         // ✅ SAVE USER SESSION
//         sessionStorage.setItem("isLoggedIn", "true");
//         sessionStorage.setItem("userId", user.user_id);
//         sessionStorage.setItem("userName", user.full_name);
//         sessionStorage.setItem("email", user.email);
//         sessionStorage.setItem("phone", user.phone || "");
        
// sessionStorage.setItem("first_name", firstName);
// sessionStorage.setItem("last_name", lastName);
// /* ================= BIGSHIP LOGIN ================= */
// try {
//   console.log("🔄 Bigship login started...");

//   const bigshipResponse = await axios.post(
//     BIGSHIP_LOGIN_URL,
//     {
//       user_name:"7385743121", 
//       password: "Sham@123",
//       access_key:
//         "7b7c5bfefcbc7ed67aae3dd2967510e0346160439f3fa48d166905110943fe19",
//     },
//     {
//       headers: {
//         "Content-Type": "application/json",
//       },
//     }
//   );

//   console.log("✅ Bigship login response:", bigshipResponse.data);

//   if (bigshipResponse.data.success === true) {
//     const bigshipToken = bigshipResponse.data.data.token;

//     // 🔐 SAVE TOKEN
//     sessionStorage.setItem("bigship_token", bigshipToken);

//     console.log("🔐 Bigship token saved in sessionStorage");
//   } else {
//     console.warn("⚠️ Bigship login failed:", bigshipResponse.data.message);
//   }
// } catch (bigshipError) {
//   console.error("❌ Bigship API error:", bigshipError);
// }

//         // 🔑 STEP 1: GET GUEST CART TOKEN
//         const cartToken = localStorage.getItem("cart_token");

//         // 🔑 STEP 2: MERGE CART (BACKEND API)
//         if (cartToken) {
//           await axios.post(
//             MERGE_CART_URL,
//             {
//               user_id: user.user_id,
//               cart_token: cartToken
//             },
//             { headers: { "Content-Type": "application/json" } }
//           );

//           // 🔑 STEP 3: REMOVE GUEST TOKEN
//           localStorage.removeItem("cart_token");
//         }

//         onClose();

//         // 🔁 STEP 4: REDIRECT AFTER LOGIN
//         const redirect = sessionStorage.getItem("redirectAfterLogin");
//         if (redirect) {
//           sessionStorage.removeItem("redirectAfterLogin");
//           navigate(redirect);
//         } else {
//           navigate("/");
//         }

//       } else {
//         alert(response.data.message || "Login Failed");
//       }

//     } catch (error) {
//       console.error(error);
//       alert("API Error");
//     }
//   };

//   if (!show) return null;

//   return (
//     <>
//       <div
//         className="modal fade show d-block"
//         tabIndex="-1"
//         style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
//       >
//         <div className="modal-dialog modal-dialog-centered">
//           <div className="modal-content">

//             {/* Header */}
//             <div
//               className="modal-header no-border d-flex flex-column align-items-center position-relative pt-0"
//               style={{ borderBottom: "none" }}
//             >
//               <div className="w-100 d-flex justify-content-between align-items-center p-0">
//                 <h3 className="modal-title fw-bold text-center pt-0 text-dark fs-2">
//                   Login
//                 </h3>
//                 <button
//                   type="button"
//                   className="btn-close"
//                   onClick={onClose}
//                 ></button>
//               </div>
//             </div>

//             {/* Body */}
//             <div className="modal-body pt-0">
//               <form onSubmit={handleSubmit}>

//                 {/* Email */}
//                 <div className="mb-3 pt-2">
//                   <label className="form-label">Email address</label>
//                   <input
//                     type="email"
//                     name="email"
//                     className="form-control"
//                     placeholder="Enter email"
//                     value={formData.email}
//                     onChange={handleChange}
//                     required
//                   />
//                 </div>

//                 {/* Password */}
//                 {/* <div className="mb-3">
//                   <label className="form-label">Password</label>
//                   <input
//                     type="password"
//                     name="password"
//                     className="form-control"
//                     placeholder="Enter password"
//                     value={formData.password}
//                     onChange={handleChange}
//                     required
//                   />
//                 </div> */}
// <div className="mb-3 position-relative">
//   <label className="form-label">Password</label>

//   <input
//     type={showPassword ? "text" : "password"}
//     name="password"
//     className="form-control pe-5"
//     placeholder="Enter password"
//     value={formData.password}
//     onChange={handleChange}
//     required
//   />

//   {/* 👁 Bootstrap Icon */}
//   <i
//     className={`bi ${showPassword ? "bi-eye-slash" : "bi-eye"}`}
//     onClick={() => setShowPassword(!showPassword)}
//     style={{
//       position: "absolute",
//       top: "70%",
//       right: "15px",
//       transform: "translateY(-50%)",
//       cursor: "pointer",
//       fontSize: "18px",
//       color: "#3a3f43ff"
//     }}
//   ></i>
// </div>

//                 {/* Checkbox + ForgetPassword */}
//                 {/* <div className="d-flex justify-content-between align-items-center mb-3">
//                   <div className="form-check">
//                     <input
//                       type="checkbox"
//                       className="form-check-input"
//                       id="remember"
//                     />
//                     <label className="form-check-label" htmlFor="remember">
//                       Remember me
//                     </label>
//                   </div> 
//                   <span
//                     className="text-danger text-decoration-underline"
//                     style={{ cursor: "pointer" }}
//                     onClick={() => setShowPassword(true)}
//                   >
//                     Forget Password
//                   </span>
//                 </div> */}

//                 {/* Submit */}
//                 <button
//                   type="submit"
//                   className="bg-col fw-bold text-light border-0 mt-3 rounded-2 p-2 w-100"
//                 >
//                   Login
//                 </button>

//                 {/* SignUp toggle */}
//                 <div className="d-flex justify-content-center align-items-center gap-1 pt-3 pb-1">
//                   <span>Don't have an account?</span>
//                   <span
//                     className="text-primary text-decoration-underline"
//                     style={{ cursor: "pointer" }}
//                     onClick={() => setShowSignUp(true)}
//                   >
//                     SignUp
//                   </span>
//                 </div>
//               </form>
//             </div>

//           </div>
//         </div>
//       </div>

//       {/* Signup Modal */}
//       <Registration
//         show={showSignUp}
//         onClose={() => setShowSignUp(false)}
//       />
//     </>
//   );
// }

// export default LoginAPI;
//gm 16-02-2026 before claude
// import { useState } from "react";
// import axios from "axios";
// import { useNavigate } from "react-router-dom";
// import { useWishlist } from "../../Context/WishlistContext";
// const LOGIN_URL = "https://ecom.cyberathon.com/index.php/Api/login_registration";
// const MERGE_CART_URL = "https://ecom.cyberathon.com/index.php/Api/merge_cart";
// const BIGSHIP_LOGIN_URL = "/api-bigship/api/login/user";

// function LoginAPI({ show, onClose, openSignUp }) {  // ✅ openSignUp prop add kiya

//   const navigate = useNavigate();
// const { mergeWishlistAfterLogin ,setUserId, loadWishlist} = useWishlist();

//   // const [showSignUp, setShowSignUp] = useState(false);  // ❌ REMOVE THIS
//   const [showPassword, setShowPassword] = useState(false);

//   const [formData, setFormData] = useState({
//     email: "",
//     password: ""
//   });

//   const handleChange = (e) => {
//     setFormData({
//       ...formData,
//       [e.target.name]: e.target.value
//     });
//   };

//   /* ================= LOGIN SUBMIT ================= */
//   // const handleSubmit = async (e) => {
//   //   e.preventDefault();

//   //   try {
//   //     const response = await axios.post(LOGIN_URL, formData, {
//   //       headers: { "Content-Type": "application/json" }
//   //     });

//   //     if (response.data.status === true) {

//   //       const user = response.data.user;
//   //       const fullName = user.full_name || "";
//   //       const nameParts = fullName.trim().split(" ");
//   //       const firstName = nameParts[0] || "";
//   //       const lastName = nameParts.slice(1).join(" ");

//   //       sessionStorage.setItem("isLoggedIn", "true");
//   //       sessionStorage.setItem("userId", user.user_id);
//   //       sessionStorage.setItem("userName", user.full_name);
//   //       sessionStorage.setItem("email", user.email);
//   //       sessionStorage.setItem("phone", user.phone || "");
//   //       sessionStorage.setItem("first_name", firstName);
//   //       sessionStorage.setItem("last_name", lastName);

//   //       /* ================= BIGSHIP LOGIN ================= */
//   //       try {
//   //         console.log("🔄 Bigship login started...");

//   //         const bigshipResponse = await axios.post(
//   //           BIGSHIP_LOGIN_URL,
//   //           {
//   //             user_name:"7385743121", 
//   //             password: "Sham@123",
//   //             access_key:
//   //               "7b7c5bfefcbc7ed67aae3dd2967510e0346160439f3fa48d166905110943fe19",
//   //           },
//   //           {
//   //             headers: {
//   //               "Content-Type": "application/json",
//   //             },
//   //           }
//   //         );

//   //         console.log("✅ Bigship login response:", bigshipResponse.data);

//   //         if (bigshipResponse.data.success === true) {
//   //           const bigshipToken = bigshipResponse.data.data.token;
//   //           sessionStorage.setItem("bigship_token", bigshipToken);
//   //           console.log("🔐 Bigship token saved in sessionStorage");
//   //         } else {
//   //           console.warn("⚠️ Bigship login failed:", bigshipResponse.data.message);
//   //         }
//   //       } catch (bigshipError) {
//   //         console.error("❌ Bigship API error:", bigshipError);
//   //       }

//   //       const cartToken = localStorage.getItem("cart_token");

//   //       if (cartToken) {
//   //         await axios.post(
//   //           MERGE_CART_URL,
//   //           {
//   //             user_id: user.user_id,
//   //             cart_token: cartToken
//   //           },
//   //           { headers: { "Content-Type": "application/json" } }
//   //         );

//   //         localStorage.removeItem("cart_token");
//   //       }
//   //        setUserId(user.user_id);
//   //       await mergeWishlistAfterLogin();
//   //       await loadWishlist();
//   //       onClose();

//   //       const redirect = sessionStorage.getItem("redirectAfterLogin");
//   //       if (redirect) {
//   //         sessionStorage.removeItem("redirectAfterLogin");
//   //         navigate(redirect);
//   //       } else {
//   //         navigate("/");
//   //       }

//   //     } else {
//   //       alert(response.data.message || "Login Failed");
//   //     }

//   //   } catch (error) {
//   //     console.error(error);
//   //     alert("API Error");
//   //   }
//   // };
// const handleSubmit = async (e) => {
//   e.preventDefault();

//   try {
//     const response = await axios.post(LOGIN_URL, formData, {
//       headers: { "Content-Type": "application/json" }
//     });

//     if (response.data.status === true) {
//       const user = response.data.user;
//       const fullName = user.full_name || "";
//       const nameParts = fullName.trim().split(" ");
//       const firstName = nameParts[0] || "";
//       const lastName = nameParts.slice(1).join(" ");

//       // ✅ Session storage set karo
//       sessionStorage.setItem("isLoggedIn", "true");
//       sessionStorage.setItem("userId", user.user_id);
//       sessionStorage.setItem("userName", user.full_name);
//       sessionStorage.setItem("email", user.email);
//       sessionStorage.setItem("phone", user.phone || "");
//       sessionStorage.setItem("first_name", firstName);
//       sessionStorage.setItem("last_name", lastName);

//       console.log("✅ User logged in:", user.user_id);

//       /* ================= BIGSHIP LOGIN ================= */
//       try {
//         const bigshipResponse = await axios.post(BIGSHIP_LOGIN_URL, {
//           user_name: "7385743121",
//           password: "Sham@123",
//           access_key: "7b7c5bfefcbc7ed67aae3dd2967510e0346160439f3fa48d166905110943fe19",
//         });

//         if (bigshipResponse.data.success === true) {
//           sessionStorage.setItem("bigship_token", bigshipResponse.data.data.token);
//           console.log("🔐 Bigship token saved");
//         }
//       } catch (bigshipError) {
//         console.error("❌ Bigship API error:", bigshipError);
//       }

//       /* ================= CART MERGE ================= */
//       const cartToken = localStorage.getItem("cart_token");
//       if (cartToken) {
//         await axios.post(MERGE_CART_URL, {
//           user_id: user.user_id,
//           cart_token: cartToken
//         });
//         localStorage.removeItem("cart_token");
//         console.log("✅ Cart merged");
//       }

//       /* ================= WISHLIST MERGE ================= */
//       console.log("🔄 Starting wishlist merge...");
//       setUserId(user.user_id); // ✅ Context mein userId set karo
//       await mergeWishlistAfterLogin(); // ✅ Merge function call karo
//       console.log("✅ Wishlist merge completed");

//       onClose();

//       const redirect = sessionStorage.getItem("redirectAfterLogin");
//       if (redirect) {
//         sessionStorage.removeItem("redirectAfterLogin");
//         navigate(redirect);
//       } else {
//         navigate("/");
//       }

//     } else {
//       alert(response.data.message || "Login Failed");
//     }
//   } catch (error) {
//     console.error(error);
//     alert("API Error");
//   }
// };
//   if (!show) return null;

//   return (
//     <div
//       className="modal fade show d-block"
//       tabIndex="-1"
//       style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
//     >
//       <div className="modal-dialog modal-dialog-centered">
//         <div className="modal-content">

//           {/* Header */}
//           <div
//             className="modal-header no-border d-flex flex-column align-items-center position-relative pt-0"
//             style={{ borderBottom: "none" }}
//           >
//             <div className="w-100 d-flex justify-content-between align-items-center p-0">
//               <h3 className="modal-title fw-bold text-center pt-0 text-dark fs-2">
//                 Login
//               </h3>
//               <button
//                 type="button"
//                 className="btn-close"
//                 onClick={onClose}
//               ></button>
//             </div>
//           </div>

//           {/* Body */}
//           <div className="modal-body pt-0">
//             <form onSubmit={handleSubmit}>

//               {/* Email */}
//               <div className="mb-3 pt-2">
//                 <label className="form-label">Email address</label>
//                 <input
//                   type="email"
//                   name="email"
//                   className="form-control"
//                   placeholder="Enter email"
//                   value={formData.email}
//                   onChange={handleChange}
//                   required
//                 />
//               </div>

//               {/* Password */}
//               <div className="mb-3 position-relative">
//                 <label className="form-label">Password</label>

//                 <input
//                   type={showPassword ? "text" : "password"}
//                   name="password"
//                   className="form-control pe-5"
//                   placeholder="Enter password"
//                   value={formData.password}
//                   onChange={handleChange}
//                   required
//                 />

//                 <i
//                   className={`bi ${showPassword ? "bi-eye-slash" : "bi-eye"}`}
//                   onClick={() => setShowPassword(!showPassword)}
//                   style={{
//                     position: "absolute",
//                     top: "70%",
//                     right: "15px",
//                     transform: "translateY(-50%)",
//                     cursor: "pointer",
//                     fontSize: "18px",
//                     color: "#3a3f43ff"
//                   }}
//                 ></i>
//               </div>

//               {/* Submit */}
//               <button
//                 type="submit"
//                 className="bg-col fw-bold text-light border-0 mt-3 rounded-2 p-2 w-100"
//               >
//                 Login
//               </button>

//               {/* SignUp toggle */}
//               <div className="d-flex justify-content-center align-items-center gap-1 pt-3 pb-1">
//                 <span>Don't have an account?</span>
//                 <span
//                   className="text-primary text-decoration-underline"
//                   style={{ cursor: "pointer" }}
//                   onClick={openSignUp}  // ✅ Direct parent function call
//                 >
//                   SignUp
//                 </span>
//               </div>
//             </form>
//           </div>

//         </div>
//       </div>
//     </div>
    
//     // ❌ REMOVE REGISTRATION COMPONENT FROM HERE
//   );
// }

// export default LoginAPI;






//claude 2nd try 16feb

import { useState } from "react";
import axios from "axios";
import { createPortal } from "react-dom";
import { useNavigate } from "react-router-dom";
import { useWishlist } from "../../Context/WishlistContext";

const LOGIN_URL = "https://ecom.cyberathon.com/index.php/Api/login_registration";
const MERGE_CART_URL = "https://ecom.cyberathon.com/index.php/Api/merge_cart";
const BIGSHIP_LOGIN_URL = "/api-bigship/api/login/user";

function LoginAPI({ show, onClose, openSignUp, openForgot }) {
  const navigate = useNavigate();
  const { mergeWishlistAfterLogin, setUserId } = useWishlist();

  const [showPassword, setShowPassword] = useState(false);

  const [formData, setFormData] = useState({
    // email: "",
    login:"",
    password: ""
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  /* ================= LOGIN SUBMIT ================= */
  const handleSubmit = async (e) => {
    e.preventDefault();

  const isEmail = /\S+@\S+\.\S+/.test(formData.login);
  const isPhone = /^[0-9]{10}$/.test(formData.login);

  const payload = {
    password: formData.password
  };

  if (isEmail) {
    payload.email = formData.login;
  } else if (isPhone) {
    payload.phone = formData.login;
  } else {
    alert("Enter valid email or 10 digit mobile number");
    return;
  }

    try {
      const response = await axios.post(LOGIN_URL, payload, {
        headers: { "Content-Type": "application/json" }
      });

      if (response.data.status === true) {
        const user = response.data.user;
        const fullName = user.full_name || "";
        const nameParts = fullName.trim().split(" ");
        const firstName = nameParts[0] || "";
        const lastName = nameParts.slice(1).join(" ");

        // ✅ 1️⃣ PEHLE SessionStorage Set Karo
        sessionStorage.setItem("isLoggedIn", "true");
        sessionStorage.setItem("userId", user.user_id);
        sessionStorage.setItem("userName", user.full_name);
        sessionStorage.setItem("email", user.email);
        sessionStorage.setItem("phone", user.phone || "");
        sessionStorage.setItem("first_name", firstName);
        sessionStorage.setItem("last_name", lastName);

        console.log("✅ User logged in:", user.user_id);

        /* ================= BIGSHIP LOGIN ================= */
        try {
          console.log("🔄 Bigship login started...");

          const bigshipResponse = await axios.post(
            BIGSHIP_LOGIN_URL,
            {
              user_name: "7385743121",
              password: "Sham@123",
              access_key:
                "7b7c5bfefcbc7ed67aae3dd2967510e0346160439f3fa48d166905110943fe19",
            },
            {
              headers: {
                "Content-Type": "application/json",
              },
            }
          );

          console.log("✅ Bigship login response:", bigshipResponse.data);

          if (bigshipResponse.data.success === true) {
            const bigshipToken = bigshipResponse.data.data.token;
            sessionStorage.setItem("bigship_token", bigshipToken);
            console.log("🔐 Bigship token saved in sessionStorage");
          } else {
            console.warn("⚠️ Bigship login failed:", bigshipResponse.data.message);
          }
        } catch (bigshipError) {
          console.error("❌ Bigship API error:", bigshipError);
        }

        /* ================= CART MERGE ================= */
        const cartToken = localStorage.getItem("cart_token");

        if (cartToken) {
          await axios.post(
            MERGE_CART_URL,
            {
              user_id: user.user_id,
              cart_token: cartToken
            },
            { headers: { "Content-Type": "application/json" } }
          );

          localStorage.removeItem("cart_token");
          console.log("✅ Cart merged");
        }

        /* ================= WISHLIST MERGE ================= */
        console.log("🔄 Starting wishlist merge...");
        
        // ✅ 2️⃣ Context mein userId set karo (synchronously)
        setUserId(user.user_id);
        console.log("🔄 Context userId set to:", user.user_id);

        // ✅ 3️⃣ Ab merge karo with direct userId pass
        await mergeWishlistAfterLogin(user.user_id); // 🔥 IMPORTANT: userId pass karo
        console.log("✅ Wishlist merge completed");

        // onClose();

        // const redirect = sessionStorage.getItem("redirectAfterLogin");
        // if (redirect) {
        //   sessionStorage.removeItem("redirectAfterLogin");
        //   navigate(redirect);
        // } else {
        //   navigate("/");
        // }
onClose();

const buyNowProduct = sessionStorage.getItem("buyNowProduct");
const redirect = sessionStorage.getItem("redirectAfterLogin");

console.log("BuyNowProduct after login:", buyNowProduct);

if (buyNowProduct) {

  const product = JSON.parse(buyNowProduct);

  navigate("/Bill", {
    state: {
      buyNow: true,
      product: product
    }
  });

  sessionStorage.removeItem("buyNowProduct");
  sessionStorage.removeItem("redirectAfterLogin");

} else if (redirect) {

  navigate(redirect);
  sessionStorage.removeItem("redirectAfterLogin");

} else {

  navigate("/");
}
      } else {
        alert(response.data.message || "Login Failed");
      }

    } catch (error) {
      console.error(error);
      alert("API Error");
    }
  };

  if (!show) return null;

  return createPortal (
    <div
      className="modal fade show d-block"
      tabIndex="-1"
      style={{ backgroundColor: "rgba(0,0,0,0.5)" ,
         position: "fixed",   // 🔥 ADD THIS
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    zIndex: 20000
       }}
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">

          {/* Header */}
          <div
            className="modal-header no-border d-flex flex-column align-items-center position-relative pt-0"
            style={{ borderBottom: "none" }}
          >
            <div className="w-100 d-flex justify-content-between align-items-center p-0">
              <h3 className="modal-title fw-bold text-center pt-0 text-dark fs-2">
                Login
              </h3>
              <button
                type="button"
                className="btn-close"
                onClick={onClose}
              ></button>
            </div>
          </div>

          {/* Body */}
          <div className="modal-body pt-0">
            <form onSubmit={handleSubmit}>

              {/* Email */}
              <div className="mb-3 pt-2">
                <label className="form-label">Email or Mobile Number</label>
                {/* <input
                  type="email"
                  name="email"
                  className="form-control"
                  placeholder="Enter email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                /> */}
                <input
  type="text"
  name="login"
  className="form-control"
  placeholder="Enter email or mobile number"
  value={formData.login}
  onChange={handleChange}
  required
/>
              </div>

              {/* Password */}
              <div className="mb-3 position-relative">
                <label className="form-label">Password</label>

                <input
                  type={showPassword ? "text" : "password"}
                  name="password"
                  className="form-control pe-5"
                  placeholder="Enter password"
                  value={formData.password}
                  onChange={handleChange}
                  required
                />

                <i
                  // className={`bi ${showPassword ? "bi-eye-slash" : "bi-eye"}`}
                   className={`bi ${showPassword ? "bi-eye" : "bi-eye-slash"}`}
                  onClick={() => setShowPassword(!showPassword)}
                  style={{
                    position: "absolute",
                    top: "70%",
                    right: "15px",
                    transform: "translateY(-50%)",
                    cursor: "pointer",
                    fontSize: "18px",
                    color: "#3a3f43ff"
                  }}
                ></i>
              </div>
 <div className="text-end mb-0">
  <span
    className="text-primary"
    style={{ cursor: "pointer", fontSize: "14px" }}
    onClick={() => {
      onClose();       // login modal band
      openForgot();    // forgot modal open
    }}
  >
    Forgot Password?
  </span>
</div>
              {/* Submit */}
              <button
                type="submit"
                className="bg-col fw-bold text-light border-0 mt-3 rounded-2 p-2 w-100"
              >
                Login
              </button>

              {/* SignUp toggle */}
              <div className="d-flex justify-content-center align-items-center gap-1 pt-3 pb-1">
                <span>Don't have an account?</span>
                <span
                  className="text-primary text-decoration-underline"
                  style={{ cursor: "pointer" }}
                  onClick={openSignUp}
                >
                  SignUp
                </span>
              </div>
             
            </form>
          </div>

        </div>
      </div>
    </div>,
     document.body // 🔥 Renders outside header's stacking context
  );
}

export default LoginAPI;